import { render } from "./Calendars.vue?vue&type=template&id=24356552"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Calendars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24356552"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24356552', __exports__)) {
    api.reload('24356552', __exports__)
  }
  
  module.hot.accept("./Calendars.vue?vue&type=template&id=24356552", () => {
    api.rerender('24356552', render)
  })

}


export default __exports__